<template>
 <div>
   <section id="doctors" class="doctors">
     <div class="container">
       <div class="section-title" style="margin-top: 7%;">
         <h2>Doctors</h2>
         <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint
           consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat
           sit
           in iste officiis commodi quidem hic quas.</p>
       </div>

       <div class="row">
         <div class="col-8">
           <p class="col-description">You Can sort the doctors list according to your needs.</p>
         </div>
         <div class="col-4">
           <div>
             <b-dropdown text="Sort Doctors list by" block variant="outline-success" class="m-2" menu-class="w-100">
               <b-dropdown-item href="#" class="dropdownitem">Action</b-dropdown-item>
               <b-dropdown-item href="#" class="dropdownitem">Another action</b-dropdown-item>
               <b-dropdown-item href="#" class="dropdownitem">Something else here</b-dropdown-item>
             </b-dropdown>
           </div>
         </div>
       </div>

       <div class="row">

         <div class="col-lg-6 mt-4" v-for="doctor in MockData" :key="doctor.id">
           <div class="member d-flex align-items-start">
             <div class="pic" v-if="doctor.image!==null">
               <img :src="getImageUrl(doctor)" class="img-fluid" alt="">
             </div>
             <div class="pic" v-else>
               <img src='./../../../../public/assets/img/default_doctor_image.png' class="img-fluid" alt="">
             </div>
             <div class="member-info">
               <h4>{{doctor.name}}</h4>
               <span>{{doctor.designation}}</span>
               <p>{{doctor.workplace}}</p>
               <div class="social">
                   <b-button variant='success' class="ml-1" @click="setModal(doctor)">Booking</b-button>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </section>

   <b-pagination
       v-model="pagination_page_number"
       :total-rows=rows
       :per-page=per_page
       first-text="First"
       prev-text="Prev"
       next-text="Next"
       last-text="Last"
       align="center"
       pills
       @input="paginatipnChanged"
   ></b-pagination>

   <b-modal ref="my-modal" centered title="Ekhoni Doctor">
     <div class="d-block text-center">
       <h3>{{selected_doctor_name}}</h3>
     </div>
     <b-form>

       <b-form-group id="patient_name_group" label="Enter The Name Of Patient:" label-for="patient_name"
                     description="Select Patient From Your Patient List">
         <b-form-select id="patient_name" required v-model="appiontment_form.patient_id">
           <div v-if="patient_data!==null">
             <option v-for="patient in patient_data" :key="patient.id" :value="patient.id" menu-class="w-100" >
               {{patient.name}}
             </option>
           </div>
         </b-form-select>
       </b-form-group>

       <b-row>
         <b-col>
           <div>
             <b-form-group id="date_group" label="Date" label-for="date" description="Select date of appiontment">
               <b-form-select id="date" block required v-model="selceted_time_slots" text="Select Date" @input="setslots" >
                 <option v-for="per in times" :key="per.start_time" :value="per" menu-class="w-100" >
                   {{per.start_time.split(' ')[0]}}
                 </option>
               </b-form-select>
               <h3 v-if="selceted_time_slots!==null">{{selceted_time_slots.start_time.split(' ')[0]}}</h3>
             </b-form-group>
           </div>
         </b-col>
         <b-col>
           <b-form-group id="time_group" label="Appointment Time :" label-for="time" description="Select time of appiontment">
               <b-row flex v-if="appionment_slots!==null">
<!--                 <b-form-select id="time" required v-model="selected.times"></b-form-select>-->
                 <div v-for="slots in appionment_slots" :key="slots.time" >
                   <b-button class="appiontmentButton" :variant="slots.status===0 ? 'success' : 'danger' " @click="setAppiontment(slots.time)"
                     :disabled="slots.status===0 ? false : true">
                     {{makeTimeAmPm(slots.time)}}
                   </b-button>
                 </div>
               </b-row>
           </b-form-group>
         </b-col>
       </b-row>
     </b-form>

     <template v-slot:modal-footer>
       <b-button v-if="getUser!==null" size="sm" variant="success" @click="confirm">
         Confirm
       </b-button>
       <b-button v-else size="sm" variant="success" @click="gotologin" >
         Login
       </b-button>
       <b-button size="sm" variant="danger" @click="cancel">
         Cancel
       </b-button>

     </template>
   </b-modal>

 </div>
</template>

<script>

import DoctorService from "@/services/general_user/doctor.service"
import {mapGetters} from "vuex";
import {Form} from "vform";
import moment from "moment";
import FetchPatientService from "@/services/general_user/fetch_patient.service";

export default {
  name: "DoctorsList",
  data() {
    return {
      pagination_page_number:1,
      rows: null,
      per_page: null,
      MockData: null,
      patient_data: null,
      selceted_time_slots: null,
      appionment_slots: null,
      selected_doctor_name: null,
      appiontment_form:new Form({
        patient_id: null,
        doctor_id: null,
        start_time: null,
        end_time: null,
      }),
      options: [
        // { value: null, text: 'Please select an option' },
         {value: null, text: 'Please Select Patient\'s Name', disabled: true},
         'NAFIS FUAD' , 'RADOWAN MAHMUD REDOY' , 'AHMED RYAN'
      ],
      times: null,
    };
  },
  computed:{
    ...mapGetters('generalUserAuth', ['getUser']),
  },
  methods:{
    makeTimeAmPm(time){
      let temp = moment(time,). format('LLLL');
      let temptime = temp.split(' ')[4];
      let format = temp.split(' ')[5];

     return `${temptime} ${format}`;
    },
    setModal(doctor){
        DoctorService.fetchDoctorSchedulebyDoctor(doctor.id)
            .then((response) =>{
              if(response.status===200){
                console.log(response.data);
                this.times=response.data;
              }
            })
        this.$refs['my-modal'].show();
        this.selected_doctor_name=doctor.name;
        this.appiontment_form.doctor_id=doctor.id;
    },
    setslots(){
      // console.log(JSON.parse(this.selceted_time_slots.schedule_slots));
      this.appionment_slots= JSON.parse(this.selceted_time_slots.schedule_slots);
    },
    paginatipnChanged(){
      console.log(this.pagination_page_number);
      var doctortype_id= window.location.href.split('=')[1];
      DoctorService.fetchDoctorOfaPartcularType(doctortype_id,this.pagination_page_number);
    },
    confirm(){
      console.log(this.appiontment_form);
      DoctorService.setAppiontment(this.appiontment_form)
      .then((response) =>{
          if(response.status===201){
            alert("appiontment fixed");
            console.log(response.data);
          }
      })
    },
    setAppiontment(start_time){
      this.appiontment_form.start_time = moment(start_time).format("YYYY-MM-DDTHH:mm:ss.SZ");
      this.appiontment_form.end_time =moment(start_time).add(20, 'minutes').format("YYYY-MM-DDTHH:mm:ss.SZ");
    },
    cancel(){
      this.selected_doctor_name=null;
      this.selceted_time_slots=null;
      this.appionment_slots=null;
      this.$refs['my-modal'].hide();
    },
    getImageUrl(doctor){
      // if(doctor.image===null){
      //   console.log("yes");
      //   // return ('..\/..\/..\/assets\/images\/app_icon.png');
      //   return './../../../../public/assets/img/default_doctor_image.png';
      // }
      // else
      return `${process.env.VUE_APP_BACKEND_URL}/${doctor.image}`;
    },
    gotologin(){
        this.$router.push({name : 'generalUserLogin'});
    }
  },
  mounted() {
    var doctortype_id= window.location.href.split('=')[1];
    DoctorService.fetchDoctorOfaPartcularType(doctortype_id)
    .then((response) =>{
      if(response.status===200){
        this.MockData= response.data.data;
        this.rows= response.data.total;
        this.per_page= response.data.per_page;
      }
    })

    if(this.getUser!==null){
      FetchPatientService.fetchPatient(this.getUser.id)
          .then((response) =>{
            if(response.status===200){
              this.patient_data=response.data;
            }
          })
    }
  }
}
</script>

<style scoped>
  .col-description{
    font-weight: bold;
    font-family: sans-serif;
    font-size: 16px;
    color: #1A86D0;
    margin-left: 4%;
    margin-top: 1%;
  }
  .dropdownitem{
    padding: 3px;
  }

  .appiontmentButton{
    margin: 5px;
    font-size: 12px;
    font-weight: bold;
  }

</style>